import { Button, Heading, Text } from "components/common";
import React, { useState } from "react";
import classes from "./Plans.module.css";
import clsx from "clsx";
import CreateInvestmentsModal from "Modals/Dashboard/CreateInvestmentsModal/CreateInvestmentsModal";
import DepositModal from "Modals/Dashboard/DepositModal/DepositModal";
import GenerateAddressModal from "Modals/Dashboard/GenerateAddressModal/GenerateAddressModal";
import TransactionDetailsModal from "Modals/Dashboard/TransactionDetailsModal/TransactionDetailsModal";
import { open_position } from "helpers/api/apis";
import { toast } from "react-toastify";
const SinglePlan = ({ el, userData, showCapitalAccess, setShowCapitalAccess, goToSignUp, isLoggedIn }) => {
  const [showCreateInvestmentModal, setShowCreateInvestmentModal] =
    useState(false);
  const [showDepositModal, setShowDepositModal] = useState(false);
  const [showGenerateAddressModal, setShowGenerateAddressModal] =
    useState(false);
  const [showTransactionDetailsModal, setShowTransactionDetailsModal] =
    useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [showInterestTooltip, setShowInterestTooltip] = useState(false);
  let sufficientBalance = true;

  const [amount, setAmount] = useState();

  const [newInvestment, setNewInvestment] = useState({});
  // let sufficientBalance = userData?.balance >= el?.minimum_amount;
  return (
    <>
      <div className={classes.card}>
        <div className={classes.cardHeader}>
          <Text sm primitive0 font600 className={classes.type}>
            {el?.name}
          </Text>
          {el.popular && (
            <Text sm primitive600 font600 className={classes.popular}>
              Popular
            </Text>
          )}
        </div>
        <Heading xl4>
          {el?.interest_rate}%
          <span className={classes.dailyInterest}> {el?.interest_schedule}</span>
          {/* <Text semiBold xl primitive800 className={classes.interestDuration}>
            For {el.duration} {
              el.duration_in.toLowerCase() == "days" && el.duration == 1 ? "day" : el.duration_in.toLowerCase() == "days" ? "days" : el.duration_in.toLowerCase() == "weeks" && el.duration == 1 ? "week" : el.duration_in.toLowerCase() == "weeks" ? "weeks" : el.duration_in.toLowerCase() == "months" && el.duration == 1 ? "month" : el.duration_in.toLowerCase() == "months" ? "months" : ""
            }
          </Text> */}
        </Heading>
        <Text base primitive700>
          {el?.info}
        </Text>
        <Button
          btnPrimary

          disabled={!sufficientBalance}
          wFull
          className={classes.button}
          onClick={() => {
            
            if (goToSignUp && !isLoggedIn) {
              window.location.href = "/sign-up";
            } else {
              if (!sufficientBalance) {
                alert("Insufficient Balance")
              }
              setShowCreateInvestmentModal(true)
            }
          }}
        >
          {
            !sufficientBalance ? "Insufficient Balance" : "Invest Now"
          }
        </Button>
        <div className={classes.depositInfo}>
          {/*  */}
          <div className={classes.spaceBetween} >
            <Text className={classes.key} primitive700 base>
              Min. Deposit
            </Text>
            <Text
              // className={clsx(
              //   classes.value,
              //   info.value.toLowerCase() === "completed"
              //     ? classes.completed
              //     : info.value.toLowerCase() === "pending"
              //       ? classes.pending
              //       : info.value.toLowerCase() === "active"
              //         ? classes.active
              //         : info.value.toLowerCase() === "failed"
              //           ? classes.failed
              //           : ""
              // )}
              primitive800
              base
              semiBold
            >
              {(el?.minimum_amount)} USD
            </Text>
          </div>
          {/*  */}

          <div className={classes.spaceBetween} >
            <Text className={classes.key} primitive700 base>
              Max. Deposit
            </Text>
            <Text
              // className={clsx(
              //   classes.value,
              //   info.value.toLowerCase() === "completed"
              //     ? classes.completed
              //     : info.value.toLowerCase() === "pending"
              //       ? classes.pending
              //       : info.value.toLowerCase() === "active"
              //         ? classes.active
              //         : info.value.toLowerCase() === "failed"
              //           ? classes.failed
              //           : ""
              // )}
              primitive800
              base
              semiBold
            >
              {el?.maximum_amount} USD
            </Text>
          </div>
          {/*  */}
          <div className={classes.spaceBetween} >
            <div className={classes.lockInPeriodContainer}>
              <Text className={classes.key} primitive700 base>
                Interest Schedule
              </Text>
              <div className={classes.infoIcon} onMouseEnter={() => setShowInterestTooltip(true)} onMouseLeave={() => setShowInterestTooltip(false)}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8C14.6667 4.3181 11.6819 1.33333 8 1.33333C4.3181 1.33333 1.33333 4.3181 1.33333 8C1.33333 11.6819 4.3181 14.6667 8 14.6667Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M8 10.6667V8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M8 5.33333H8.00667" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                {showInterestTooltip && (
                  <div className={classes.tooltip}>
                    <Text primitive800 base>
                      Interest is available for instant withdrawal, making it a flexible investment option. You can access your earned interest at any time without waiting periods or restrictions.
                    </Text>
                  </div>
                )}
              </div>
            </div>
            <Text
              primitive800
              base
              semiBold
            >
              Paid {el?.interest_schedule}
            </Text>
          </div>
          {/*  */}
          <div className={classes.spaceBetween} >
            <Text className={classes.key} primitive700 base>
              Management Fee
            </Text>
            <Text
              // className={clsx(
              //   classes.value,
              //   info.value.toLowerCase() === "completed"
              //     ? classes.completed
              //     : info.value.toLowerCase() === "pending"
              //       ? classes.pending
              //       : info.value.toLowerCase() === "active"
              //         ? classes.active
              //         : info.value.toLowerCase() === "failed"
              //           ? classes.failed
              //           : ""
              // )}
              primitive800
              base
              semiBold
            >
              {/* {el?.duration}  {
                el.duration_in.toLowerCase() == "days" && el.duration == 1 ? "day" : el.duration_in.toLowerCase() == "days" ? "days" : el.duration_in.toLowerCase() == "weeks" && el.duration == 1 ? "week" : el.duration_in.toLowerCase() == "weeks" ? "weeks" : el.duration_in.toLowerCase() == "months" && el.duration == 1 ? "month" : el.duration_in.toLowerCase() == "months" ? "months" : ""
              } */}
              0.0%
            </Text>
            
          </div>
          {/*  */}

          <div className={classes.spaceBetween} >
            <Text className={classes.key} primitive700 base>
              Status
            </Text>
            <Text
              className={clsx(
                classes.value,
                el?.status.toLowerCase() === "completed"
                  ? classes.completed
                  : el?.status.toLowerCase() === "pending"
                    ? classes.pending
                    : el?.status.toLowerCase() === "active"
                      ? classes.active
                      : el?.status.toLowerCase() === "failed"
                        ? classes.failed
                        : ""
              )}
              primitive800
              base
              semiBold
            >
              {el?.status}
            </Text>
          </div>
       
        </div>
        <div className={classes.capitalAccessSection}>
          <div 
            className={classes.capitalAccessHeader}
            onClick={() => setShowCapitalAccess(!showCapitalAccess)}
          >
            <Text className={classes.sectionTitle} primitive700 base>
              Investment Terms
            </Text>
            <div className={clsx(classes.arrow, showCapitalAccess && classes.arrowOpen)}>
              <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1L6 6L11 1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          </div>
          {showCapitalAccess && (
            <div className={classes.capitalAccessList}>
              <div className={classes.capitalAccessItem}>
                <div className={classes.bulletPoint} />
                <Text primitive800 base>
                  Withdraw after 5 months – no fee
                </Text>
              </div>
              <div className={classes.capitalAccessItem}>
                <div className={classes.bulletPoint} />
                <Text primitive800 base>
                  Early withdrawal – subject to a break fee of (10% of principal)
                </Text>
              </div>
              <div className={classes.capitalAccessItem}>
                <div className={classes.bulletPoint} />
                <div className={classes.lockInPeriodContainer}>
                  <Text primitive800 base>
                    Capital Return: Principal amount will be available for withdrawal after the 5-month lock-in period
                  </Text>
                  <div 
                    className={classes.infoIcon}
                    onMouseEnter={() => setShowTooltip(true)}
                    onMouseLeave={() => setShowTooltip(false)}
                  >
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8C14.6667 4.3181 11.6819 1.33333 8 1.33333C4.3181 1.33333 1.33333 4.3181 1.33333 8C1.33333 11.6819 4.3181 14.6667 8 14.6667Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M8 10.6667V8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M8 5.33333H8.00667" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    {showTooltip && (
                      <div className={classes.tooltip}>
                        <Text sm primitive700>
                          A "lock-in period" is a predetermined timeframe during which investors are restricted from selling or withdrawing their investment, such as shares or units in a mutual fund. This period aims to encourage long-term investing, ensure stability in the market, and prevent potential price manipulation
                        </Text>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <CreateInvestmentsModal
        userData={userData}
        amount={amount}
        setAmount={setAmount}
        isActive={showCreateInvestmentModal}
        position={el}
        el={el}
        setNewInvestment={setNewInvestment}
        newInvestment={newInvestment}
        setShowTransactionDetailsModal={setShowTransactionDetailsModal}
        showTransactionDetailsModal={showTransactionDetailsModal}

       
        onClose={() => setShowCreateInvestmentModal(false)}
      />{" "}

      <TransactionDetailsModal
        investment={newInvestment}
        isActive={showTransactionDetailsModal}
        onClick={() => { }}
        onClose={() => {
          window.location.href = "/dashboard";
          setShowTransactionDetailsModal(false);
        }}
      />
      <DepositModal
        isActive={showDepositModal}
        onClick={() => {
          setShowGenerateAddressModal(true);
        }}
        onClose={() => setShowDepositModal(false)}
      />
      <GenerateAddressModal
        isActive={showGenerateAddressModal}
        onClick={() => {
          setShowTransactionDetailsModal(true);
        }}
        onClose={() => setShowGenerateAddressModal(false)}
      />{" "}

    </>
  );
};

export default SinglePlan;
